import { render, staticRenderFns } from "./RewardInfo.vue?vue&type=template&id=c3a54d42"
import script from "./RewardInfo.vue?vue&type=script&lang=js"
export * from "./RewardInfo.vue?vue&type=script&lang=js"
import style0 from "./RewardInfo.vue?vue&type=style&index=0&id=c3a54d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports